(() => {
	angular.module('main').directive('eventTypeCell', eventTypeCell);

	eventTypeCell.$inject = ['$location', 'customizeLabelsService'];

	function eventTypeCell($location, customizeLabelsService) {
		return {
			restrict: 'AE',
			scope: {
				eventData: '=snData'
			},
			template: `
                    <div class="calendar__item__wrap">
                        <div ng-hide="::isMainShoot(eventData) || (isExt(eventData) && isInLead(eventData)) || (isApp(eventData) && isInLead(eventData))" class="calendar__item">
                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                            <div class="calendar__item__body">
                                <b class="event__time">
                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                                </b>
                                <span>{{::setEventName(eventData)}}</span> 
                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}}</b>
                                </br>
                             
                            </div>
                        </div>
                        
                        <div ng-if="::isApp(eventData) && isInLead(eventData)" class="calendar__item">
                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                            <div class="calendar__item__body">
                                <b class="event__time">
                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                                </b>
                                <span>{{::setEventName(eventData)}}</span> 
                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>
                                </br>
                              
                            </div>
                        </div>
                        
                        <div ng-if="::isExt(eventData) && isInLead(eventData)" class="calendar__item">
                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                            <div class="calendar__item__body">
                                <b class="event__time">
                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                                </b>
                                <span>{{::setEventName(eventData)}}</span> 
                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>
                                </br>
                              
                            </div>
                        </div>
                        
                        <a class="calendar__item__link" ng-mousedown="goToEvent($event,eventData)" ng-href="/jobs/view/{{eventData.jobId}}" >
                        <div ng-if="::isMainShoot(eventData) && isInLead(eventData)===false" class="calendar__item">
                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                            <div class="calendar__item__body">
                                <b class="event__time">
                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                                </b>
                                <span>{{::setEventName(eventData)}}</span> 
                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}}</b>
                                </br>
                                <b ng-if="::eventData.typeColor === 'LEAD' && eventType === 'MAIN SHOOT'" class="event__type event__type-{{::eventColor | lowercase}}">UNCONFIRMED</b>
                            </div>
                        </div>
                        </a>
                        
                        <a class="calendar__item__link" ng-mousedown="goToEvent($event,eventData)" ng-href="/leads/view/{{eventData.leadId}}">
                        <div ng-if="::isMainShoot(eventData) && isInLead(eventData)===true" class="calendar__item">
                            <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                            <div class="calendar__item__body">
                                <b class="event__time">
                                    {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                                </b>
                                <span>{{::setEventName(eventData)}}</span> 
                                <b class="event__type event__type-{{::eventColor | lowercase}}">{{::eventType}} (LEAD)</b>
                                </br>
                              
                            </div>
                        </div>
                        </a>
                    </div>  
        `,
			replace: true,
			transclude: true,
			link(scope) {
				scope.isMainShoot = event => event.calendarEventType === 'MAIN_SHOOT';
				scope.isExt = event => event.calendarEventType === 'EXTRA_SHOOT';
				scope.isApp = event => event.calendarEventType === 'APPOINTMENT';
				scope.isInLead = event => event.inLead;

				if (scope.eventData) {
					setEventType(scope.eventData);
				}

				scope.goToEvent = (event, eventData) => {
					// 0 left mouse btn
					if (event.button === 0) {
						event.preventDefault();
						// clear query parameters in url
						$location.url('/');
						// redirect to lead or jobs
						eventData.inLead
							? $location.path(`/leads/view/${eventData.leadId}`)
							: $location.path(`/jobs/view/${eventData.jobId}`);
					}
				};

				scope.setEventName = event => {
					if (!event) {
						return '';
					}

					if (event.jobName && !scope.isMainShoot(event)) {
						return `${event.jobName} - ${event.name}`;
					}
					return event.name;
				};

				function setEventType(event) {
					if (
						event.calendarEventType === 'MAIN_SHOOT' &&
						event.inLead === false
					) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'MAIN_SHOOT' &&
						event.inLead === true
					) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'EXTRA_SHOOT' &&
						event.inLead === false
					) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'EXTRA_SHOOT' &&
						event.inLead === true
					) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else {
						scope.eventColor = 'APPOINTMENT';
						scope.eventType = 'APPOINTMENT';
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/PageCalendar/eventTypeCell.js